const Flickity = require('flickity-imagesloaded');
const FlickityFade = require('flickity-fade');
const slider = document.querySelector('.slider');
const cardSliders = document.querySelectorAll('.cardSlider');
const logoSliders = document.querySelectorAll('.logoSlider');

if (slider) {
	let flkty = new FlickityFade( slider, {
		cellAlign: 'left',
		wrapAround: true,
		dots: true,
		autoPlay: 5000,
		pauseAutoPlayOnHover: false,
		prevNextButtons: false,
		fade: true,
	});

	window.addEventListener('load', () => {
		flkty.resize();
	})

	window.addEventListener('resize', () => {
		flkty.resize();
	})
}

if (cardSliders) {

	cardSliders.forEach( (item) => {

		let flkty = new Flickity( item, {
			cellAlign: 'center',
			wrapAround: true,
			dots: false,
			autoPlay: false,
			pauseAutoPlayOnHover: false,
			prevNextButtons: true,
			imagesLoaded: true
		});

		window.addEventListener('load', () => {
			flkty.resize();
		})

		window.addEventListener('resize', () => {
			flkty.resize();
		})
	})
}

if (logoSliders) {

	logoSliders.forEach( (item) => {

		let flkty = new Flickity( item, {
			cellAlign: 'left',
			wrapAround: true,
			dots: false,
			autoPlay: 5000,
			pauseAutoPlayOnHover: false,
			prevNextButtons: false,
			imagesLoaded: true
		});

		window.addEventListener('load', () => {
			flkty.resize();
		})

		window.addEventListener('resize', () => {
			flkty.resize();
		})
	})
}